import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  setValidFieldAction,
  removeValidFieldAction,
  setInvalidFieldAction,
  removeInvalidFieldAction,
} from "features/application/field/redux/actions";

import FieldView from "features/application/field/component/view";

const mapStateToProps = (state) => ({
  validFields: state.fieldReducer.validFields,
  invalidFields: state.fieldReducer.invalidFields,
});

const mapDispatchToProps = (dispatch) => ({
  setValidField: (name) => dispatch(setValidFieldAction(name)),
  removeValidField: (name) => dispatch(removeValidFieldAction(name)),
  setInvalidField: (name) => dispatch(setInvalidFieldAction(name)),
  removeInvalidField: (name) => dispatch(removeInvalidFieldAction(name)),
});

class Field extends Component {
  constructor(props) {
    super(props);

    this.references = {
      password: React.createRef(),
      gender: React.createRef(),
      genderPreview: React.createRef(),
      genderList: React.createRef(),
    };

    this.validate = this.validate.bind(this);
    this.removeError = this.removeError.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.toggleGenderListVisibility = this.toggleGenderListVisibility.bind(
      this
    );
    this.setGender = this.setGender.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", (event) => this.hiddenGenderList(event));
  }

  componentWillUnmount() {
    document.removeEventListener("click", (event) =>
      this.hiddenGenderList(event)
    );
  }

  hiddenGenderList(event) {
    if (this.references.genderList.current) {
      let genderList = this.references.genderList.current;

      genderList &&
        event.target.nodeName !== "SELECT" &&
        event.target.className !== "field__gender" &&
        (genderList.style.visibility = "hidden");
    }
  }

  setError(name) {
    const { removeValidField, setInvalidField } = this.props;

    removeValidField(name);
    setInvalidField(name);
  }

  removeError(name) {
    const { setValidField, removeInvalidField } = this.props;

    setValidField(name);
    removeInvalidField(name);
  }

  checkField(value, regex, name) {
    value.trim().match(regex) ? this.removeError(name) : this.setError(name);
  }

  validate(name, value, rule, shouldValidate) {
    if (shouldValidate) {
      switch (rule) {
        case "required":
          this.checkField(value, /^(.|\n|\r){2,}$/, name);
          break;
        case "email":
          this.checkField(
            value,
            /^[a-zA-Z0-9!#$%&'*+\-./=?^_`{|}~]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
            name
          );
          break;
        case "password":
          this.checkField(
            value,
            /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{8,64}$/,
            name
          );
          break;
        case "gender":
          value && (value === "Male" || value === "Female" || value === "Other")
            ? this.removeError(name)
            : this.setError(name);
          this.checkField(value);
          break;
        case "day":
          this.checkField(value, /^(0?[1-9]|[12]\d|3[01])$/, name);
          break;
        case "month":
          this.checkField(value, /^(0?[1-9]|1[0-2])$/, name);
          break;
        case "year":
          this.checkField(value, /^(19|20)\d{2}$/, name);
          break;
        case "zipCode":
          this.checkField(value, /^.{3,10}$/, name);
          break;
        case "link":
          this.checkField(value, /^((?!\s).){2,}$/, name);
          break;
        case "photo":
          (value &&
            (value.type === "image/jpeg" || value.type === "image/png")) ||
          this.props.photoError
            ? this.removeError(name)
            : this.setError(name);
          break;
        case "checkbox":
          value ? this.removeError(name) : this.setError(name);
          break;
        case "cardNumber":
          this.checkField(
            value,
            /^(\d{15}|\d{4} \d{6} \d{5}|\d{16}|\d{4} \d{4} \d{4} \d{4})$/,
            name
          );
          break;
        case "validity":
          this.checkField(value, /^(0[1-9]|1[0-2])\/\d{2}$/, name);
          break;
        case "cvv":
          this.checkField(value, /^\d{3,4}$/, name);
          break;
        case "phone":
          this.checkField(
            value,
            /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s0-9]*$/,
            name
          );
          break;
      }
    } else {
      this.removeError(name);
    }
  }

  togglePasswordVisibility() {
    if (this.references.password.current) {
      let password = this.references.password.current;

      password.type === "password"
        ? (password.type = "text")
        : (password.type = "password");
    }
  }

  toggleGenderListVisibility() {
    if (this.references.gender.current && this.references.genderList.current) {
      let gender = this.references.gender.current;
      let genderList = this.references.genderList.current;
      let focusEvent = new Event("focus", { bubbles: true, cancelable: true });

      genderList.style.visibility === "hidden"
        ? (genderList.style.visibility = "visible")
        : (genderList.style.visibility = "hidden");

      gender.dispatchEvent(focusEvent);
    }
  }

  setGender(event) {
    if (
      this.references.gender.current &&
      this.references.genderPreview.current
    ) {
      let gender = this.references.gender.current;
      let genderPreview = this.references.genderPreview.current;
      let blurEvent = new Event("blur", { bubbles: true, cancelable: true });

      gender.value = event.target.dataset.gender;
      gender.dispatchEvent(blurEvent);
      genderPreview.innerHTML = event.target.dataset.gender;
    }
  }

  render() {
    const {
      label,
      placeholder,
      name,
      type,
      accept,
      autoComplete,
      maxLength,
      value,
      isChecked,
      image,
      invalidFields,
      shouldValidate,
      rule,
      error,
      reference,
      styles,
      removeInvalidField,
      handleChange,
      disabled,
    } = this.props;

    return (
      <FieldView
        label={label}
        placeholder={placeholder}
        name={name}
        type={type}
        accept={accept}
        autoComplete={autoComplete}
        maxLength={maxLength}
        value={value}
        isChecked={isChecked}
        image={image}
        invalidFields={invalidFields}
        shouldValidate={shouldValidate}
        rule={rule}
        error={error}
        reference={reference}
        references={this.references}
        styles={styles}
        removeInvalidField={removeInvalidField}
        validate={this.validate}
        togglePasswordVisibility={this.togglePasswordVisibility}
        toggleGenderListVisibility={this.toggleGenderListVisibility}
        setGender={this.setGender}
        handleChange={handleChange}
        photoError={this.props.photoError}
        disabled={disabled}
      />
    );
  }
}

Field.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  accept: PropTypes.string,
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  isChecked: PropTypes.bool,
  image: PropTypes.string,
  invalidFields: PropTypes.array,
  shouldValidate: PropTypes.bool,
  rule: PropTypes.string,
  error: PropTypes.string,
  reference: PropTypes.object,
  removeValidField: PropTypes.func,
  setInvalidField: PropTypes.func,
  setValidField: PropTypes.func,
  removeInvalidField: PropTypes.func,
  styles: PropTypes.object,
  handleChange: PropTypes.func,
  photoError: PropTypes.string,
  disabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Field);
